import { Button, ButtonRow, Card, FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import type { IStepProps } from '../NewGhcRequest';
import { translateKey } from '../../../../translate';

export function Step4(props: IStepProps) {
    return (
        <>
            <Card.Header title="We hebben alleen nog de volgende gegevens nodig." />
            <Card.Body>
                <FormSection>
                    <FormGroup
                        hasErrors={props.errors.has('practitionerName')}
                        label="De naam van je huisarts"
                    >
                        <TextInput
                            error={
                                props.errors.get('practitionerName')
                                    ? translateKey('validation.' + props.errors.get('practitionerName'))
                                    : undefined
                            }
                            onChange={(e) => props.handleChange({ practitionerName: e.target.value })}
                            placeholder="Bv: dr. H.J. de Jong"
                            value={props.request.customControlData.practitionerName || ''}
                        />
                    </FormGroup>

                    <FormGroup
                        hasErrors={props.errors.has('organizationName')}
                        label="De praktijknaam van je huisarts"
                    >
                        <TextInput
                            error={
                                props.errors.get('organizationName')
                                    ? translateKey('validation.' + props.errors.get('organizationName'))
                                    : undefined
                            }
                            onChange={(e) => props.handleChange({ organizationName: e.target.value })}
                            placeholder="Organisatienaam..."
                            value={props.request.customControlData.organizationName || ''}
                        />
                    </FormGroup>
                </FormSection>
                <FormSection isBorderless>
                    <ButtonRow justify="center">
                        <Button
                            onClick={props.validateAndGoToNextStep}
                            type="button"
                            variant="solid"
                        >
                            Volgende
                        </Button>
                    </ButtonRow>
                </FormSection>
            </Card.Body>
        </>
    );
}
